/* ==========================================================================
  main.js
========================================================================== */

'use strict';
/* global fitvids, cssVars */

/**
 * Init responsive videos
 */
fitvids();

/**
 * Init CSS vars ponyfill
 */
cssVars({});

var MTUserId = 'e12ec566-8d09-4f20-b95a-e4e7840c6e6b';
var MTFontIds = new Array();

MTFontIds.push('5748625'); // FF Fago® W01 Regular
MTFontIds.push('5748648'); // FF Fago® W01 Medium
MTFontIds.push('5748668'); // FF Fago® W01 Bold
MTFontIds.push('5748757'); // FF Fago® W01 Condensed Bold
(function () {
  var mtTracking = document.createElement('script');
  mtTracking.type = 'text/javascript';
  mtTracking.async = 'true';
  mtTracking.src =
    '/wp-content/themes/prh-mallioikeuskampanja/mtiFontTrackingCode.js';

  (
    document.getElementsByTagName('head')[0] ||
    document.getElementsByTagName('body')[0]
  ).appendChild(mtTracking);
})();

// Add external image to all target blank anchors
/*
document.addEventListener('DOMContentLoaded', function (event) {
  document
    .querySelectorAll(".entry__content a[target='_blank']:not(.c-button)")
    .forEach((e) => {
      // don't do with mailto links
      if (e.href.includes('youtube')) {
        return false;
      }
      e.innerHTML +=
        "<img class='external-link' src='" +
        directory_uri.stylesheet_directory_uri +
        "/dist/images/external.svg' alt='Aukeaa uuteen selaimen välilehteen' />";
    });

  // in footer menu
  document
    .querySelectorAll(".footer-navigation a[target='_blank']")
    .forEach((e) => {
      e.innerHTML +=
        "<img class='external-link' src='" +
        directory_uri.stylesheet_directory_uri +
        "/dist/images/external-white.svg' alt='Aukeaa uuteen selaimen välilehteen' />";
    });
});
*/
